module.exports = __webpack_public_path__ + "static/media/freedance_icon.c8f09b02.svg";